var _circle, _rect, _rect2, _path, _circle2, _circle3, _circle4, _rect3, _g, _line, _rect4, _g2, _line2, _rect5, _g3, _line3, _rect6, _g4, _line4, _rect7, _g5, _line5, _rect8, _g6, _line6, _rect9, _g7, _line7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedbackImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 241,
    viewBox: "0 0 241 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.18,
    cy: 120.288,
    r: 96,
    fill: "#CCE9FB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.4993,
    y: 51.4214,
    width: 73.3609,
    height: 137.733,
    rx: 8,
    fill: "#00558A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.2736,
    y: 55.3401,
    width: 65.8124,
    height: 129.896,
    rx: 5.21219,
    fill: "#62C3FF",
    stroke: "#62C3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.643 54.8401H135.284V57.5515C135.284 59.2723 133.889 60.6672 132.168 60.6672H113.759C112.038 60.6672 110.643 59.2723 110.643 57.5515V54.8401Z",
    fill: "#00558A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.18,
    cy: 180.712,
    r: 1.30211,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 114.521,
    cy: 180.712,
    r: 1.30211,
    fill: "white",
    fillOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 125.838,
    cy: 180.712,
    r: 1.30211,
    fill: "white",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 57.8723,
    height: 12.3932,
    rx: 2.07716,
    transform: "matrix(1 0 0 -1 91.2726 77.4309)",
    fill: "#EAF7FF",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_10383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.963 73.6716C101.814 73.6716 101.671 73.6124 101.565 73.5069C101.46 73.4014 101.4 73.2583 101.4 73.1091C101.4 72.9599 101.46 72.8169 101.565 72.7114C101.671 72.6059 101.814 72.5466 101.963 72.5466C102.112 72.5466 102.255 72.6059 102.361 72.7114C102.466 72.8169 102.525 72.9599 102.525 73.1091C102.525 73.2583 102.466 73.4014 102.361 73.5069C102.255 73.6124 102.112 73.6716 101.963 73.6716ZM102.525 70.2966L103.26 71.2341H101.588V70.2966M97.463 73.6716C97.3138 73.6716 97.1707 73.6124 97.0652 73.5069C96.9597 73.4014 96.9005 73.2583 96.9005 73.1091C96.9005 72.9599 96.9597 72.8169 97.0652 72.7114C97.1707 72.6059 97.3138 72.5466 97.463 72.5466C97.6121 72.5466 97.7552 72.6059 97.8607 72.7114C97.9662 72.8169 98.0255 72.9599 98.0255 73.1091C98.0255 73.2583 97.9662 73.4014 97.8607 73.5069C97.7552 73.6124 97.6121 73.6716 97.463 73.6716ZM102.713 69.7341H101.588V68.2341H96.338C95.9217 68.2341 95.588 68.5679 95.588 68.9841V73.1091H96.338C96.338 73.4075 96.4565 73.6936 96.6675 73.9046C96.8784 74.1156 97.1646 74.2341 97.463 74.2341C97.7613 74.2341 98.0475 74.1156 98.2584 73.9046C98.4694 73.6936 98.588 73.4075 98.588 73.1091H100.838C100.838 73.4075 100.956 73.6936 101.167 73.9046C101.378 74.1156 101.665 74.2341 101.963 74.2341C102.261 74.2341 102.547 74.1156 102.758 73.9046C102.969 73.6936 103.088 73.4075 103.088 73.1091H103.838V71.2341L102.713 69.7341Z",
    fill: "#62C3FF"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 109.661,
    y1: 71.3098,
    x2: 143.118,
    y2: 71.3098,
    stroke: "#62C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 57.8723,
    height: 12.3932,
    rx: 2.07716,
    transform: "matrix(1 0 0 -1 91.2726 93.8242)",
    fill: "#EAF7FF",
    fillOpacity: 0.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_79_10383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.963 90.0649C101.814 90.0649 101.671 90.0057 101.565 89.9002C101.46 89.7947 101.4 89.6516 101.4 89.5024C101.4 89.3533 101.46 89.2102 101.565 89.1047C101.671 88.9992 101.814 88.9399 101.963 88.9399C102.112 88.9399 102.255 88.9992 102.361 89.1047C102.466 89.2102 102.525 89.3533 102.525 89.5024C102.525 89.6516 102.466 89.7947 102.361 89.9002C102.255 90.0057 102.112 90.0649 101.963 90.0649ZM102.525 86.6899L103.26 87.6274H101.588V86.6899M97.463 90.0649C97.3138 90.0649 97.1707 90.0057 97.0652 89.9002C96.9597 89.7947 96.9005 89.6516 96.9005 89.5024C96.9005 89.3533 96.9597 89.2102 97.0652 89.1047C97.1707 88.9992 97.3138 88.9399 97.463 88.9399C97.6121 88.9399 97.7552 88.9992 97.8607 89.1047C97.9662 89.2102 98.0255 89.3533 98.0255 89.5024C98.0255 89.6516 97.9662 89.7947 97.8607 89.9002C97.7552 90.0057 97.6121 90.0649 97.463 90.0649ZM102.713 86.1274H101.588V84.6274H96.338C95.9217 84.6274 95.588 84.9612 95.588 85.3774V89.5024H96.338C96.338 89.8008 96.4565 90.087 96.6675 90.2979C96.8784 90.5089 97.1646 90.6274 97.463 90.6274C97.7613 90.6274 98.0475 90.5089 98.2584 90.2979C98.4694 90.087 98.588 89.8008 98.588 89.5024H100.838C100.838 89.8008 100.956 90.087 101.167 90.2979C101.378 90.5089 101.665 90.6274 101.963 90.6274C102.261 90.6274 102.547 90.5089 102.758 90.2979C102.969 90.087 103.088 89.8008 103.088 89.5024H103.838V87.6274L102.713 86.1274Z",
    fill: "#62C3FF"
  }))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 109.661,
    y1: 87.7031,
    x2: 143.118,
    y2: 87.7031,
    stroke: "#62C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 57.8723,
    height: 12.3932,
    rx: 2.07716,
    transform: "matrix(1 0 0 -1 91.2726 110.217)",
    fill: "#EAF7FF",
    fillOpacity: 0.5
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_79_10383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.963 106.458C101.814 106.458 101.671 106.399 101.565 106.293C101.46 106.188 101.4 106.045 101.4 105.896C101.4 105.746 101.46 105.603 101.565 105.498C101.671 105.392 101.814 105.333 101.963 105.333C102.112 105.333 102.255 105.392 102.361 105.498C102.466 105.603 102.525 105.746 102.525 105.896C102.525 106.045 102.466 106.188 102.361 106.293C102.255 106.399 102.112 106.458 101.963 106.458ZM102.525 103.083L103.26 104.021H101.588V103.083M97.463 106.458C97.3138 106.458 97.1707 106.399 97.0652 106.293C96.9597 106.188 96.9005 106.045 96.9005 105.896C96.9005 105.746 96.9597 105.603 97.0652 105.498C97.1707 105.392 97.3138 105.333 97.463 105.333C97.6121 105.333 97.7552 105.392 97.8607 105.498C97.9662 105.603 98.0255 105.746 98.0255 105.896C98.0255 106.045 97.9662 106.188 97.8607 106.293C97.7552 106.399 97.6121 106.458 97.463 106.458ZM102.713 102.521H101.588V101.021H96.338C95.9217 101.021 95.588 101.354 95.588 101.771V105.896H96.338C96.338 106.194 96.4565 106.48 96.6675 106.691C96.8784 106.902 97.1646 107.021 97.463 107.021C97.7613 107.021 98.0475 106.902 98.2584 106.691C98.4694 106.48 98.588 106.194 98.588 105.896H100.838C100.838 106.194 100.956 106.48 101.167 106.691C101.378 106.902 101.665 107.021 101.963 107.021C102.261 107.021 102.547 106.902 102.758 106.691C102.969 106.48 103.088 106.194 103.088 105.896H103.838V104.021L102.713 102.521Z",
    fill: "#62C3FF"
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 109.661,
    y1: 104.096,
    x2: 143.118,
    y2: 104.096,
    stroke: "#62C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 57.8723,
    height: 12.3932,
    rx: 2.07716,
    transform: "matrix(1 0 0 -1 91.2726 126.611)",
    fill: "#EAF7FF",
    fillOpacity: 0.5
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_79_10383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.963 122.851C101.814 122.851 101.671 122.792 101.565 122.687C101.46 122.581 101.4 122.438 101.4 122.289C101.4 122.14 101.46 121.997 101.565 121.891C101.671 121.786 101.814 121.726 101.963 121.726C102.112 121.726 102.255 121.786 102.361 121.891C102.466 121.997 102.525 122.14 102.525 122.289C102.525 122.438 102.466 122.581 102.361 122.687C102.255 122.792 102.112 122.851 101.963 122.851ZM102.525 119.476L103.26 120.414H101.588V119.476M97.463 122.851C97.3138 122.851 97.1707 122.792 97.0652 122.687C96.9597 122.581 96.9005 122.438 96.9005 122.289C96.9005 122.14 96.9597 121.997 97.0652 121.891C97.1707 121.786 97.3138 121.726 97.463 121.726C97.6121 121.726 97.7552 121.786 97.8607 121.891C97.9662 121.997 98.0255 122.14 98.0255 122.289C98.0255 122.438 97.9662 122.581 97.8607 122.687C97.7552 122.792 97.6121 122.851 97.463 122.851ZM102.713 118.914H101.588V117.414H96.338C95.9217 117.414 95.588 117.748 95.588 118.164V122.289H96.338C96.338 122.587 96.4565 122.873 96.6675 123.084C96.8784 123.295 97.1646 123.414 97.463 123.414C97.7613 123.414 98.0475 123.295 98.2584 123.084C98.4694 122.873 98.588 122.587 98.588 122.289H100.838C100.838 122.587 100.956 122.873 101.167 123.084C101.378 123.295 101.665 123.414 101.963 123.414C102.261 123.414 102.547 123.295 102.758 123.084C102.969 122.873 103.088 122.587 103.088 122.289H103.838V120.414L102.713 118.914Z",
    fill: "#62C3FF"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 109.661,
    y1: 120.49,
    x2: 143.118,
    y2: 120.49,
    stroke: "#62C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 57.8723,
    height: 12.3932,
    rx: 2.07716,
    transform: "matrix(1 0 0 -1 91.2726 143.004)",
    fill: "#EAF7FF",
    fillOpacity: 0.5
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_79_10383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.963 139.244C101.814 139.244 101.671 139.185 101.565 139.08C101.46 138.974 101.4 138.831 101.4 138.682C101.4 138.533 101.46 138.39 101.565 138.284C101.671 138.179 101.814 138.119 101.963 138.119C102.112 138.119 102.255 138.179 102.361 138.284C102.466 138.39 102.525 138.533 102.525 138.682C102.525 138.831 102.466 138.974 102.361 139.08C102.255 139.185 102.112 139.244 101.963 139.244ZM102.525 135.869L103.26 136.807H101.588V135.869M97.463 139.244C97.3138 139.244 97.1707 139.185 97.0652 139.08C96.9597 138.974 96.9005 138.831 96.9005 138.682C96.9005 138.533 96.9597 138.39 97.0652 138.284C97.1707 138.179 97.3138 138.119 97.463 138.119C97.6121 138.119 97.7552 138.179 97.8607 138.284C97.9662 138.39 98.0255 138.533 98.0255 138.682C98.0255 138.831 97.9662 138.974 97.8607 139.08C97.7552 139.185 97.6121 139.244 97.463 139.244ZM102.713 135.307H101.588V133.807H96.338C95.9217 133.807 95.588 134.141 95.588 134.557V138.682H96.338C96.338 138.98 96.4565 139.266 96.6675 139.477C96.8784 139.688 97.1646 139.807 97.463 139.807C97.7613 139.807 98.0475 139.688 98.2584 139.477C98.4694 139.266 98.588 138.98 98.588 138.682H100.838C100.838 138.98 100.956 139.266 101.167 139.477C101.378 139.688 101.665 139.807 101.963 139.807C102.261 139.807 102.547 139.688 102.758 139.477C102.969 139.266 103.088 138.98 103.088 138.682H103.838V136.807L102.713 135.307Z",
    fill: "#62C3FF"
  }))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 109.661,
    y1: 136.883,
    x2: 143.118,
    y2: 136.883,
    stroke: "#62C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 57.8723,
    height: 12.3932,
    rx: 2.07716,
    transform: "matrix(1 0 0 -1 91.2726 159.397)",
    fill: "#EAF7FF",
    fillOpacity: 0.5
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_79_10383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.963 155.638C101.814 155.638 101.671 155.578 101.565 155.473C101.46 155.367 101.4 155.224 101.4 155.075C101.4 154.926 101.46 154.783 101.565 154.677C101.671 154.572 101.814 154.513 101.963 154.513C102.112 154.513 102.255 154.572 102.361 154.677C102.466 154.783 102.525 154.926 102.525 155.075C102.525 155.224 102.466 155.367 102.361 155.473C102.255 155.578 102.112 155.638 101.963 155.638ZM102.525 152.263L103.26 153.2H101.588V152.263M97.463 155.638C97.3138 155.638 97.1707 155.578 97.0652 155.473C96.9597 155.367 96.9005 155.224 96.9005 155.075C96.9005 154.926 96.9597 154.783 97.0652 154.677C97.1707 154.572 97.3138 154.513 97.463 154.513C97.6121 154.513 97.7552 154.572 97.8607 154.677C97.9662 154.783 98.0255 154.926 98.0255 155.075C98.0255 155.224 97.9662 155.367 97.8607 155.473C97.7552 155.578 97.6121 155.638 97.463 155.638ZM102.713 151.7H101.588V150.2H96.338C95.9217 150.2 95.588 150.534 95.588 150.95V155.075H96.338C96.338 155.374 96.4565 155.66 96.6675 155.871C96.8784 156.082 97.1646 156.2 97.463 156.2C97.7613 156.2 98.0475 156.082 98.2584 155.871C98.4694 155.66 98.588 155.374 98.588 155.075H100.838C100.838 155.374 100.956 155.66 101.167 155.871C101.378 156.082 101.665 156.2 101.963 156.2C102.261 156.2 102.547 156.082 102.758 155.871C102.969 155.66 103.088 155.374 103.088 155.075H103.838V153.2L102.713 151.7Z",
    fill: "#62C3FF"
  }))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 109.661,
    y1: 153.276,
    x2: 143.118,
    y2: 153.276,
    stroke: "#62C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 57.8723,
    height: 12.3932,
    rx: 2.07716,
    transform: "matrix(1 0 0 -1 91.2726 175.79)",
    fill: "#EAF7FF",
    fillOpacity: 0.5
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_79_10383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.963 172.031C101.814 172.031 101.671 171.971 101.565 171.866C101.46 171.761 101.4 171.617 101.4 171.468C101.4 171.319 101.46 171.176 101.565 171.071C101.671 170.965 101.814 170.906 101.963 170.906C102.112 170.906 102.255 170.965 102.361 171.071C102.466 171.176 102.525 171.319 102.525 171.468C102.525 171.617 102.466 171.761 102.361 171.866C102.255 171.971 102.112 172.031 101.963 172.031ZM102.525 168.656L103.26 169.593H101.588V168.656M97.463 172.031C97.3138 172.031 97.1707 171.971 97.0652 171.866C96.9597 171.761 96.9005 171.617 96.9005 171.468C96.9005 171.319 96.9597 171.176 97.0652 171.071C97.1707 170.965 97.3138 170.906 97.463 170.906C97.6121 170.906 97.7552 170.965 97.8607 171.071C97.9662 171.176 98.0255 171.319 98.0255 171.468C98.0255 171.617 97.9662 171.761 97.8607 171.866C97.7552 171.971 97.6121 172.031 97.463 172.031ZM102.713 168.093H101.588V166.593H96.338C95.9217 166.593 95.588 166.927 95.588 167.343V171.468H96.338C96.338 171.767 96.4565 172.053 96.6675 172.264C96.8784 172.475 97.1646 172.593 97.463 172.593C97.7613 172.593 98.0475 172.475 98.2584 172.264C98.4694 172.053 98.588 171.767 98.588 171.468H100.838C100.838 171.767 100.956 172.053 101.167 172.264C101.378 172.475 101.665 172.593 101.963 172.593C102.261 172.593 102.547 172.475 102.758 172.264C102.969 172.053 103.088 171.767 103.088 171.468H103.838V169.593L102.713 168.093Z",
    fill: "#62C3FF"
  }))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 109.661,
    y1: 169.669,
    x2: 143.118,
    y2: 169.669,
    stroke: "#62C3FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_79_10383)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113.653,
    height: 49.2083,
    rx: 2.07716,
    transform: "matrix(1 0 0 -1 63.3531 128.669)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.95 139.807V128.619H129.141L139.95 139.807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3633 88.532C76.7891 88.532 69.8304 95.4907 69.8304 104.065C69.8304 112.639 76.7891 119.598 85.3633 119.598C93.9374 119.598 100.896 112.639 100.896 104.065C100.896 95.4907 93.9374 88.532 85.3633 88.532ZM85.3633 93.1918C87.9417 93.1918 90.0232 95.2733 90.0232 97.8517C90.0232 100.43 87.9417 102.512 85.3633 102.512C82.7848 102.512 80.7034 100.43 80.7034 97.8517C80.7034 95.2733 82.7848 93.1918 85.3633 93.1918ZM85.3633 115.249C81.4801 115.249 78.0473 113.26 76.0436 110.247C76.0902 107.156 82.2567 105.463 85.3633 105.463C88.4543 105.463 94.6364 107.156 94.683 110.247C92.6793 113.26 89.2465 115.249 85.3633 115.249Z",
    fill: "#0091EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.254 97.4974L115.606 99.5204L114.716 95.7076L117.677 93.1423L113.778 92.8114L112.254 89.2156L110.73 92.8114L106.83 93.1423L109.792 95.7076L108.902 99.5204L112.254 97.4974Z",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.985 97.4974L142.337 99.5204L141.447 95.7076L144.409 93.1423L140.509 92.8114L138.985 89.2156L137.461 92.8114L133.561 93.1423L136.523 95.7076L135.633 99.5204L138.985 97.4974Z",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.62 97.4974L128.971 99.5204L128.082 95.7076L131.043 93.1423L127.144 92.8114L125.62 89.2156L124.095 92.8114L120.196 93.1423L123.157 95.7076L122.268 99.5204L125.62 97.4974Z",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.351 97.4974L155.703 99.5204L154.813 95.7076L157.774 93.1423L153.875 92.8114L152.351 89.2156L150.827 92.8114L146.927 93.1423L149.888 95.7076L148.999 99.5204L152.351 97.4974Z",
    fill: "#F7B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.717 97.4974L169.068 99.5204L168.179 95.7076L171.14 93.1423L167.241 92.8114L165.717 89.2156L164.193 92.8114L160.293 93.1423L163.254 95.7076L162.365 99.5204L165.717 97.4974Z",
    fill: "#62C3FF",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.33,
    y1: 106.185,
    x2: 163.564,
    y2: 106.185,
    stroke: "#0091EA",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.33,
    y1: 115.523,
    x2: 140.353,
    y2: 115.523,
    stroke: "#0091EA",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_79_10383",
    x: 57.3531,
    y: 73.4609,
    width: 125.653,
    height: 72.3457,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_79_10383"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_79_10383",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_10383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(95.213 66.7341)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_79_10383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(95.213 83.1274)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_79_10383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(95.213 99.5205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_79_10383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(95.213 115.914)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_79_10383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(95.213 132.307)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_79_10383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(95.213 148.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_79_10383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "translate(95.213 165.093)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackImage);
export default __webpack_public_path__ + "static/media/feedbackImage.a006ca76f0e0ade9abfe5d10d821e0e5.svg";
export { ForwardRef as ReactComponent };